<template>
  <require-script
      v-if="apiKey"
      :src="`https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`"
  >
    <vue-google-autocomplete
        @hook:mounted="initGoogleAutocomplete"
        ref="full_address"
        id="map"
        :class="`place-google-autocomplete w-full border-solid border text-inherit ${inputClasses || ''}`"
        placeholder="Please type your address"
        @placechanged="getAddressData"
        name="full_address"
        types="address"
        country="us"
        @blur="checkInput"
        @no-results-found="() => this.$emit('no_results_found')"
    >
    </vue-google-autocomplete>
  </require-script>
  <span v-else>Missing configuration for Google Place API</span>
</template>
<script>

import VueGoogleAutocomplete from "vue-google-autocomplete";
import RequireScript from "./RequireScript.vue";
import Configuration from "../../mixins/Configuration";

/**
 * Requires Vue Google Autocomplete. Add to main project using:
 *
 * npm install vue-google-autocomplete --save
 */
export default {
  components: {RequireScript, VueGoogleAutocomplete},
  props: {
    inputClasses: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
  },
  data: function () {
    return {
      full_address: '',
      address_data: {},
    };
  },
  computed: {
    apiKey() {
      return this.getConfiguration('google.places_api_key')
    },
  },
  mixins: [Configuration],

  methods: {
    initGoogleAutocomplete() {
      if (this.value) {
        this.$refs.full_address.$el.value = this.value;
      }
    },

    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData: function (addressData, placeResultData) {
      this.full_address = {...addressData, name: placeResultData.name, full: this.$refs.full_address.$el.value};
      this.$refs.full_address.$el.value = this.full_address?.name ?? '';
      this.$emit('full_address', this.full_address);
    },
    checkInput: function () {
      if (!this.$refs.full_address.$el.value.trim()) {
        this.full_address = '';
        this.$emit('full_address', this.full_address);
      }
    },
  },
};
</script>

<style>
.place-google-autocomplete {
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  color: #202028 !important;
}
</style>
